<template>
  <div>
    <div class="container">
      <loading-wrap :loading="loading">
        <div
          v-if="error"
          class="alert alert-danger"
        >Invalid link or the assessment has surpassed it's three week expiry. Please contact Pat.</div>
        <div v-if="assessment" class="py-5">
          <h2>Report for {{assessment.firstName}} {{assessment.lastName}}</h2>
          <hr />
          <div v-if="!success">
            <div v-for="(q, i) in assessment.questions">
              <h4>{{q.order + 1}} {{q.question ? ': ' + q.question : ''}}</h4>
              <selector-card v-model="assessment.questions[i].answer" :options="q.tutorSentences" />
              <hr />
            </div>
            <label>Additional Comments</label>
            <textarea class="form-control" v-model="assessment.comments"></textarea>
            <hr />
            <label>Upload Additonal Content</label>
            <template v-if="assessment.attachments && assessment.attachments.length">
              <upload-card
                v-for="(u, i) in assessment.attachments"
                :upload="u"
                :index="i"
                @remove="remove"
              />
            </template>
            <div v-if="!fileUploading">
              <input
                type="file"
                @change="upload"
                multiple
                ref="file"
                name="file"
                accept="*"
                class="form-control-file"
              />
            </div>
            <div v-else>
              <h4>Uploading...</h4>
            </div>
            <hr />
            <div class="alert alert-danger mb-2">
              <b>NOTE:</b> You will not be able to ammend your report following submission. Please ensure this report contains all necessary information in order to be reviewed by management.
            </div>
          </div>
          <hr />
          <div class="alert alert-success" v-if="success">Submission successfully saved.</div>
          <div class="d-flex justify-content-end">
            <button type="button" @click="submit" class="btn btn-success" :disabled="formLoading">
              <svg-loader />
              <span>Submit</span>
            </button>
          </div>
        </div>
      </loading-wrap>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      loading: true,
      assessment: null,
      error: null,
      formLoading: false,
      success: null,
      loadsRequired: 0,
      fileUploading: false
    };
  },
  methods: {
    submit() {
      this.formLoading = true;
      this.success = false;

      this.axios
        .patch(`/api/assessments/${this.id}?tutor=true`, this.assessment)
        .then(res => {
          this.success = true;
        })
        .finally(() => {
          this.formLoading = false;
        });
    },
    remove(index) {
      this.assessment.attachments = [
        ...this.assessment.attachments.slice(0, index),
        ...this.assessment.attachments.slice(
          index + 1,
          this.assessment.attachments.length
        )
      ];
    },
    upload({ target: { files } }) {
      this.fileUploading = true;
      this.loadsRequired = files.length;

      const config = {
        headers: {
          "Content-Type": undefined
        }
      };

      for (const file of files) {
        const formData = new FormData();

        formData.append("file", file);

        this.axios
          .post("/api/templates/uploads", formData, config)
          .then(res => {
            this.assessment.attachments.push(res.data);
          })
          .finally(() => {
            this.loadsRequired--;

            if (this.loadsRequired === 0) {
              this.fileUploading = false;
            }
          });
      }

      this.$refs.file.value = null;
    }
  },
  created() {
    this.axios
      .get(`/api/assessments/${this.id}?tutor=true`)
      .then(res => {
        this.assessment = res.data;
        this.assessment.attachments = [];
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
